import React, { useEffect, useState } from 'react';
import * as Yup from "yup";
import Breadcrumbs from '../../components/BreadCrumbs';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, Formik } from 'formik';
import Button from '../../components/buttons/Button';
import InputField from '../../components/inputFields/InputField';
import FormikDropdown from '../../components/inputFields/FormikDropDown';
import FilePickerField from '../../components/inputFields/FilePickerField';
import { getUserId } from '../../helpers/local_storage_helpers';
import { patchBanner, postBanner } from '../../services/banner';

function BannersForm() {
    const location = useLocation();
    const navigate = useNavigate();
    const [rowData, setRowData] = useState(null);
    const [file, setFile] = useState(null);


    const handleDiscardChanges = (resetForm) => {
        resetForm();
        navigate(-1);
    };

    const handleimageSelect = (file) => {
        setFile(file);
    };

    const handleFormSubmit = async (values, { setSubmitting }) => {
        const formData = new FormData();
        if (rowData !== null) {
            if (file && typeof file !== "object") {
                toast.error("Choose an Image");
                return;
            }
        }
        if (file && typeof file === "object") {
            formData.append("image", file);
        }
        if (rowData !== null) {
            formData.append("id", rowData.id);
        }
        formData.append("type", values.banner_type);
        formData.append("title", values.title);
        if (values.link !== "") {
            formData.append("link", values.link ?? "");
        }
        formData.append("is_active", values.is_active ? "True" : "False");
        formData.append("created_by", getUserId());

        try {
            const response = rowData ? await patchBanner({ data: formData, id: rowData.id }) : await postBanner(formData);

            if (response?.status === 200 || response.status === 201) {
                toast.success(rowData ? "Banner updated successfully" : "Banner added successfully!");
                navigate(-1);
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setSubmitting(false);
    };

    useEffect(() => {
        if (location.state) {
            setRowData(location.state);
            if (location.state.file) {
                setFile(location.state.file);
            }
        }
    }, [location]);

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Banners', link: '/marketing/banners' },
            { name: rowData ? 'Update Banner' : 'Add Banner' },
        ]} />
        <div className="mt-8">
            <Formik
                initialValues={rowData || {
                    banner_type: "Dukaan",
                    title: "",
                    link: "",
                    is_active: true,
                }}
                validationSchema={Yup.object({
                    title: Yup.string().required("Title is required"),
                })}
                enableReinitialize
                onSubmit={handleFormSubmit}
            >
                {({ isSubmitting, resetForm, values, setValues }) => (
                    <Form>
                        <div className="border border-gray-300 mt-5 p-4 rounded-lg bg-gray-100 flex flex-col md:flex-row gap-4">
                            <div className="flex flex-col w-full">
                                <div className="grid gap-2 grid-cols-1 md:grid-cols-3 mb-3">
                                    <FormikDropdown
                                        label="Banner Type"
                                        name="banner_type"
                                        placeholder="Banner Type"
                                        options={[
                                            { label: "Mobile (1920X1080)", value: "Mobile" },
                                            { label: "Advertisement (1080X1080)", value: "Advertisement" },
                                            { label: "Dukaan (1200X628)", value: "Dukaan" },
                                            { label: "Website (1280X400)", value: "Website" },
                                            { label: "Mobile Home (1280X720)", value: "mobile_home" },
                                        ]}
                                    />
                                    <InputField
                                        label="Remark"
                                        name="title"
                                        banner_type="text"
                                        placeholder="Post title"
                                        required
                                    />
                                    <InputField
                                        label="Redirection Link"
                                        name="link"
                                        banner_type="url"
                                        placeholder="Link"
                                    />
                                </div>
                                <div className="grid gap-2 grid-cols-1 md:grid-cols-2 mb-3 items-end">
                                    <FilePickerField
                                        preloadedFile={file}
                                        label='Image'
                                        placeHolder={values.banner_type === "Advertisement" ? "Select File (1:1)" : 'Select File (16:9)'}
                                        onFileSelect={handleimageSelect}
                                    />
                                    <InputField
                                        label="Is Active"
                                        name="is_active"
                                        isCheckbox={true}
                                    />
                                </div>
                                <div className="py-5 flex justify-end gap-6">
                                    <div>
                                        <Button
                                            banner_type="button"
                                            className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                                            onClick={() => handleDiscardChanges(resetForm)}
                                            disabled={isSubmitting}
                                        >
                                            Discard Changes
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            banner_type="submit"
                                            className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? "Saving..." : "Save"}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    </>);
}

export default BannersForm;